export function getDisputeStageDetails(eventCode) {
    return [
        {
            eventCode: "AUTH_MATCHED",
            eventName:"Authorization",
            buttonList: [
                {
                    buttonName: "Auth Data",
                    buttonID:3,
                    buttonKey:"AuthMasterId",
                },
            ]
        },
        {
            eventCode: "TRANS_MATCHED",
            eventName:"Transaction",
            buttonList: [
                {
                    buttonName: "Tran Data",
                    buttonID:4,
                    buttonKey:"TransMasterId",
                },
            ]
        },
        {
            eventCode: "CREDIT_TRANS",
            eventName:"Credit Transaction",
            buttonList: [
                {
                    buttonName: "Tran Data",
                    buttonID:5,
                    buttonKey:"TransMasterId",
                },
            ]
        },
        {
            eventCode: "REFERENCE_TRANS",
            eventName:"Reference Transaction",
            buttonList: [
                {
                    buttonName: "Tran Data",
                    buttonID:7,
                    buttonKey:"TransMasterId",
                },
            ]
        }
    ].find((stageMetaData) => {
        return stageMetaData.eventCode === eventCode;
    });
}